import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

interface GetInTouchInput {
  message: string;
  access: boolean;
  questions: boolean;
  feedback: boolean;
}

export const sendEmail = async (payload: GetInTouchInput) => {
  return await axios.post(`${BASE_URL}/self-preview/get-in-touch`, payload, {
    withCredentials: true,
  });
};
